import React from "react";
import { FormattedMessage } from "react-intl";
import organizationFormFieldConfigs from "../../organizations/config/formFields";
import supplierFormFields from "../../suppliers/config/formFields";
import driverFormFields from "../../drivers/config/formFields";
import trucksFormFields from "../../trucks/config/formFields";
import truckTypesFormFields from "../../truckTypes/config/formFields";

const organizationNameField = organizationFormFieldConfigs.find((f) => f.name === "name");
// Remove label for UI
const OrganizationField = { ...organizationNameField, label: "" };

const disableSupplierId = (fields) =>
    fields.map((field) => {
        if (field.name === "supplierId") {
            return { ...field, disabled: true };
        }

        return field;
    });

export const supplierPartnerContractTypeData = [
    { value: 0, label: "Monthly" },
    { value: 1, label: "On Demand" },
];

export default {
    organization: {
        ...OrganizationField,
        type: "list",
        name: "organization",
    },
    branch: {
        entityName: "branches",
        name: "branch",
        type: "list",
        url: "/branches",
        filterValue: "nameAr",
        validation: {
            required: true,
        },
        helpText: <FormattedMessage id="branch-form.help-txt-name" />,
        errorMessage: <FormattedMessage id="branch-form.err-msg-name" />,
    },
    contractType: {
        entityName: "contractType",
        name: "contractType",
        type: "list",
        filterValue: "nameAr",
        validation: {
            required: true,
        },
        data: [
            { value: 0, label: "Monthly" },
            { value: 1, label: "On Demand" },
            { value: 2, label: "Daily Rental" },
        ],
        helpText: <FormattedMessage id="contract-type.help-txt-name" />,
        errorMessage: <FormattedMessage id="contract-form.err-msg-name" />,
    },
    tripsCount: {
        name: "tripsCount",
        label: "",
        type: "number",
        min: 1,
        helpText: <FormattedMessage id="order-form.help-txt-trips-count" />,
        errorMessage: <FormattedMessage id="order-form.err-msg-trips-count" />,
        validation: {
            required: true,
        },
    },

    requestDateAndTime: {
        name: "requestDateAndTime",
        type: "dateAndTime",
        helpText: <FormattedMessage id="order-form.help-txt-request-date" />,
        errorMessage: <FormattedMessage id="order-form.err-msg-request-date" />,
        validation: {
            required: true,
        },
    },
    project: {
        entityName: "project",
        name: "project",
        type: "list",
        filterValue: "name",
        errorMessage: <FormattedMessage id="order-form.err-msg-project-name" />,
        validation: {
            required: true,
        },
        helpText: <FormattedMessage id="project-form.help-txt-name" />,
    },
    trip: [
        {
            entityName: "suppliers",
            name: "supplier",
            label: <FormattedMessage id="order-form.supplier" />,
            type: "list",
            helpText: <FormattedMessage id="order-form.help-txt-supplier" />,
            url: "/suppliers",
            filterValue: "name",
            errorMessage: <FormattedMessage id="order-form.err-msg-supplier" />,
            validation: {
                required: false,
            },
            createOptions: {
                entityName: "suppliers",
                displayName: "suppliers",
                formFields: supplierFormFields,
            },
        },
        {
            entityName: "supplierContractType",
            name: "supplierContractType",
            label: <FormattedMessage id="order-form.operation-model" />,
            type: "list",
            helpText: <FormattedMessage id="order-form.help-txt-operation-model" />,
            errorMessage: <FormattedMessage id="order-form.err-msg-operation-model" />,
            data: [
                { value: "0", label: "Monthly" },
                { value: "1", label: "On-Demand" },
            ],
            validation: {
                required: false,
            },
        },
        {
            entityName: "drivers",
            name: "driver",
            label: <FormattedMessage id="order-form.driver" />,
            type: "list",
            helpText: <FormattedMessage id="order-form.help-txt-driver" />,
            url: "/drivers",
            filterValue: "name",
            errorMessage: <FormattedMessage id="order-form.err-msg-driver" />,
            validation: {
                required: false,
            },
            createOptions: {
                entityName: "drivers",
                displayName: "drivers",
                formFields: disableSupplierId(driverFormFields),
                relation: {
                    name: "supplier",
                },
            },
        },
        {
            entityName: "trucks",
            name: "truck",
            label: <FormattedMessage id="order-form.truck" />,
            type: "list",
            helpText: <FormattedMessage id="order-form.help-txt-truck" />,
            url: "/trucks",
            filterValue: "keyword",
            itemLabels: ["plateNumber", "model"],
            errorMessage: <FormattedMessage id="order-form.err-msg-truck" />,
            validation: {
                required: false,
            },
            createOptions: {
                entityName: "trucks",
                displayName: "trucks",
                formFields: disableSupplierId(trucksFormFields),
                relation: {
                    name: "supplier",
                },
            },
        },
        {
            entityName: "truckTypes",
            name: "truckType",
            label: <FormattedMessage id="order-form.truck-type" />,
            type: "list",
            helpText: <FormattedMessage id="order-form.help-txt-truck-type" />,
            url: "/truck-types",
            filterValue: "keyword",
            itemLabels: ["alias"],
            errorMessage: <FormattedMessage id="order-form.err-msg-truck-type" />,
            validation: {
                required: true,
            },
            createOptions: {
                entityName: "truckTypes",
                displayName: "truckTypes",
                formFields: truckTypesFormFields,
            },
        },
        {
            name: "pickupDateAndTime",
            label: <FormattedMessage id="order-form.pickup-date-time" />,
            type: "dateAndTime",
            helpText: <FormattedMessage id="order-form.help-txt-pickup-date" />,
            errorMessage: <FormattedMessage id="order-form.err-msg-pickup-date" />,
            validation: {
                required: true,
            },
        },
        {
            name: "tripAttachments",
            // label: 'Trip Attachments',
            type: "file",
            initialPromptText: <FormattedMessage id="order-form.prompt-txt-attachment" />,
            helpText: <FormattedMessage id="order-form.help-txt-attachment" />,
            accept: "image/jpeg,image/gif,image/png",
        },
        {
            name: "tripNotes",
            // label: 'Trip Notes',
            type: "textArea",
            helpText: <FormattedMessage id="order-form.help-txt-notes" />,
        },
    ],
};
